import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class CopyCompanyBankRulesCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(sourceCompanyId: Number | String, targetCompanyId: Number | String): Promise<any> {
    let args = {
      source_company_id: sourceCompanyId,
      target_company_id: targetCompanyId,
    }
    let res = await this.dispatcher.dispatch('copy.company.bank_rules', args);
    return res;
  }
}
